import Cookies from 'js-cookie';

// 用户的cookie选择保存13个月
export const MONTH_13 = 1000 * 60 * 60 * 24 * 30 * 13;

// 用户的cookie选择作为一个新cookie name
export const COOKIE_NAME = 'cookie-consent';

// 可选的cookie & Storage，本期只有TEA
type OptionalCookieParams = {
  teasdk?: boolean;
};

// Necessary cookies: tt_webid
const cookieDefault = { tt_webid: true };

// Necessary localStorage: slardar
const localStorageDefault = { slardar: true };

// Necessary sessionStorage: slardar
const sessionStorageDefault = { pwa: true, fbssls: true };

/**
 * 记录用户cookie设置选择
 * @param cookieParams
 */
export const setCookieChoice = (cookieParams: OptionalCookieParams = {}) => {
  const params = {
    ...cookieDefault,
    ...localStorageDefault,
    ...sessionStorageDefault,
    ...cookieParams,
  };
  const cookieVal = encodeURI(JSON.stringify(params));
  const domain = location.host.includes('localhost') ? 'localhost' : `.${location.host.split('.').slice(-2).join('.')}`;

  Cookies.set(COOKIE_NAME, cookieVal, {
    domain,
    expires: new Date(Date.now() + MONTH_13),
  });
};

/**
 * 从cookie-consent获取用户cookie设置的选择
 * @returns
 */
export const getCookieChoice = () => {
  const cookieBanner = Cookies.get(COOKIE_NAME) || '';
  try {
    return JSON.parse(decodeURI(cookieBanner));
  } catch {
    // 用户未做过任何选择，返回{}
    return {};
  }
};
